import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import './styles/main.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import sentry from '@/services/sentry'
import App from './App.vue'
import globalComponents from './components'
import globalDirectives from './directives'
import router from './router'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(sentry, router)
  .use(globalComponents)
  .use(globalDirectives)
  .mount('#app')
